import axios from 'axios'

const api = async (method, path, params) => axios[method](path, params)
const state = {
    selectedTemplate: {},
    templates: [],
}

const mutations = {
    set_template(state, payload) {
        state.selectedTemplate = payload
    },
    set_templates(state, payload) {
        state.templates = payload
    },
}

const actions = {
    /**
     * Set the selected template for a new template
     */
    newTemplate(context, payload) {
        context.commit('set_template', payload)
    },
    async create(context, payload) {
        try {
            const results = await api('post', `checkoff-template`, payload)
            const newTemplate = results.data.success.data

            const templates = [...context.state.templates]
            templates.push(newTemplate)

            context.commit('set_templates', templates)
            context.commit('set_template', newTemplate)
        } catch (err) {
            throw err
        }
    },
    async fetchById(context, template_id) {
        try {
            const path = `checkoff-template/${template_id}`
            console.log('checkoffTemplate fetchbyId template_id', template_id)
            const results = await api('get', path)
            console.log('checkoffTemplate fetchbyId results', results)
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            console.log('err', err)
            throw err
        }
    },

    async fetchAll(context) {
        try {
            const results = await api('get', `checkoff-template`)
            context.commit('set_templates', results.data.success.data)
        } catch (err) {
            throw err
        }
    },

    async update(context, payload) {
        console.log('update', payload)
        try {
            const results = await api(
                'put',
                `checkoff-template/${payload.id}`,
                payload
            )

            const template = results.data.success.data
            const templates = [...context.state.templates]

            const idx = templates.findIndex(x => x.id === template.id)
            templates.splice(idx, 1, template)

            context.commit('set_template', template)
            context.commit('set_templates', templates)
        } catch (err) {
            throw err
        }
    },
    async delete(context, template_id) {
        try {
            await api('delete', `checkoff-template/${template_id}`)
            const templates = [...context.state.templates]
            const idx = templates.findIndex(x => x.id === template_id)
            templates.splice(idx, 1)

            context.commit('set_template', null)
            context.commit('set_templates', templates)
        } catch (err) {
            throw err
        }
    },

    async createType(context, { template_id, item }) {
        try {
            const results = await api(
                'post',
                `checkoff-template/${template_id}/types`,
                item
            )
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            throw err
        }
    },

    async updateType(context, { template_id, item }) {
        try {
            const results = await api(
                'put',
                `checkoff-template/${template_id}/types/${item.id}`,
                item
            )
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            throw err
        }
    },

    async deleteType(context, { template_id, item_id }) {
        try {
            const results = await api(
                'delete',
                `checkoff-template/${template_id}/types/${item_id}`
            )
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            throw err
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
